import React from 'react'
import PropTypes from 'prop-types';
import Input from '../../../../inputs/Input';
import { XIcon } from'@heroicons/react/outline';
import utils from "../../../../shared/utils";

Distribution.propTypes = {
    onUpdate: PropTypes.func.isRequired,
    onRemove: PropTypes.func.isRequired,
    index: PropTypes.number.isRequired,
    hasAgeOverlapError: PropTypes.bool.isRequired,
    fieldErrors: PropTypes.array.isRequired,
    autoFocusStartYear: PropTypes.bool
}
  
Distribution.defaultProps = {

};

export default function Distribution(props) {

    const hasFieldError = (name) => {
        return props.fieldErrors.filter(error => error.name === name).length > 0;
    }

  return (
    <div className="bg-slate-200 mt-6 p-4">
        <div className="grid">
            <div className="flex justify-between">
                <span className="font-bold">Distribution</span>
                {props.index > 0 && (
                    <XIcon onClick={() => props.onRemove(props.index)} className="h-6 cursor-pointer" />
                )}
            </div>
            <span className="text-sm">Enter the distribution amount dispersed each year, and if a growth rate is applied</span>
        </div>
        <div className="grid grid-cols-2">
            <div className="col-span-1 flex">
                <Input
                    type="number"
                    name={`distributions[${props.index}].startYear`}
                      label={"Starting Year"}
                      onInput={(e) => {
                          e.target.value = Math.round(e.target.value);
                      }
                      }
                    containerClassNames="pr-2 py-3"
                    onChange={(e) => props.onUpdate(e.target)}
                    hasValidationError={hasFieldError(`distributions[${props.index}].startYear`) || hasFieldError(`distributions[${props.index}].years`) || props.hasAgeOverlapError}
                    autoFocus={props.autoFocusStartYear}
                />
                <Input
                    type="number"
                    name={`distributions[${props.index}].endYear`}
                      label={"Ending Year"}
                      onInput={(e) => {
                          e.target.value = Math.round(e.target.value);
                      }
                      }
                    containerClassNames="pl-2 py-3"
                    onChange={(e) => props.onUpdate(e.target)}
                    hasValidationError={hasFieldError(`distributions[${props.index}].endYear`) || hasFieldError(`distributions[${props.index}].years`) || props.hasAgeOverlapError}
                />
            </div>
            <div className="col-span-1"></div>
            <div className="col-span-1">
                <Input
                    type="number"
                      name={`distributions[${props.index}].annualIncome`}
                    symbol="$"
                    label={"Distribution Amount"}
                      onInput={(e) => {
                          e.target.value = Math.round(e.target.value);
                      }
                      }
                    containerClassNames="pr-2 py-3"
                    onChange={(e) => props.onUpdate(e.target)}
                    hasValidationError={hasFieldError(`distributions[${props.index}].annualIncome`)}
                />
            </div>
            <div className="col-span-1">
                <Input
                    type="number"
                    name={`distributions[${props.index}].costOfLivingAdjustment`}
                    label={"Distribution Amount Growth Rate"}
                    symbol="%"
                    subText="Apply COLA to your annual income"
                    optional={true}
                    containerClassNames="pl-2 py-3"
                      onInput={(e) => {
                          utils.setDecimalPlaces(e);
                      }}
                    onChange={(e) => props.onUpdate(e.target)}
                    hasValidationError={hasFieldError(`distributions[${props.index}].costOfLivingAdjustment`)}
                />
            </div>
        </div>
    </div>
    )
}
